import {
  CLEAN_DETAIL_TRANSACTIONS_STRIPE,
  CLEAN_DETAIL_TRANSACTIONS_STRIPE_ERROR,
} from '_models/redux/types';

export const cleanDetailStripeAction = () => async (dispatch) => {
  try {
    dispatch({
      payload: undefined,
      type: CLEAN_DETAIL_TRANSACTIONS_STRIPE,
    });
  } catch {
    dispatch({
      payload: undefined,
      type: CLEAN_DETAIL_TRANSACTIONS_STRIPE_ERROR,
    });
  }
};
